import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getRoutesForPoc = async () => {
  try {
    const response = await apiClient.get(`/routes/getAllRoutes/`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getAdditionalCostsForPoc = async () => {
  try {
    const response = await apiClient.get(`/routes/getAllAdditionalCost/`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteDetailTable = async (startLocation, endLocation) => {
  try {
    const response = await apiClient.get(
      `/routes/getRouteDetailTable/${startLocation}/${endLocation}`
    );
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteCostsForPoc = async (id) => {
  try {
    const response = await apiClient.get(`/routes/getRouteCost/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteOneForPoc = async (id) => {
  try {
    const response = await apiClient.get(`routes/getOneRoute/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
export const getRouteOneAdditionlForPoc = async (id) => {
  try {
    const response = await apiClient.get(`/routes/getOneRouteAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRouteOneAdditionlCount = async (id) => {
  if (!id) {
    return;
  }
  try {
    const response = await apiClient.get(`/routes/countAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
